module.exports = __webpack_public_path__ + "static/media/antal.596d0182.mp3";